import type { FormData, GeneratedSlides } from "./types";
import { normalizeN8nResponse } from "./utils";

const N8N_WEBHOOK_URL =
  "https://brennovic08.app.n8n.cloud/webhook/CriadorDeSlide";

export async function generateSlides(
  formData: FormData,
): Promise<GeneratedSlides> {
  try {
    const response = await fetch(N8N_WEBHOOK_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title: formData.title,
        subject: formData.subject,
        topic: formData.topic,
        audience: formData.audience,
        slideStyle: formData.slideStyle,
        colorScheme: formData.colorScheme,
        slideCount: formData.slideCount,
        includeImages: formData.includeImages,
        includeDiagrams: formData.includeDiagrams,
        includeExamples: formData.includeExamples,
        includeSummary: formData.includeSummary,
        customInstructions: formData.customInstructions,
      }),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const result = await response.json();

    if (!result.success || !result.data) {
      throw new Error("Invalid API response structure");
    }

    const normalized = normalizeN8nResponse(result);
    return normalized as GeneratedSlides;
  } catch (error) {
    console.error("Erro ao gerar slides:", error);
    throw error;
  }
}

export async function savePresentationToStorage(
  key: string,
  data: GeneratedSlides,
): Promise<void> {
  try {
    await (window as any).storage?.set(key, JSON.stringify(data));
  } catch (error) {
    console.error("Erro ao salvar apresentação:", error);
    throw error;
  }
}

export async function loadPresentationsFromStorage(): Promise<
  GeneratedSlides[]
> {
  try {
    const result = await (window as any).storage?.list("presentation:");
    if (!result || !result.keys) return [];

    const presentations = await Promise.all(
      result.keys.map(async (key: string) => {
        try {
          const data = await (window as any).storage?.get(key);
          return data ? JSON.parse(data.value) : null;
        } catch {
          return null;
        }
      }),
    );

    return presentations.filter(Boolean);
  } catch (error) {
    console.error("Erro ao carregar apresentações:", error);
    return [];
  }
}

export async function deletePresentationFromStorage(id: string): Promise<void> {
  try {
    await (window as any).storage?.delete(`presentation:${id}`);
  } catch (error) {
    console.error("Erro ao excluir apresentação:", error);
    throw error;
  }
}
